module.exports = __webpack_public_path__ + "static/img/z5.1e98b7a4.png";